export enum EventType {
  JOB_REQUEST = 'JOB_REQUEST',
  JOB_REQUEST_ANSWERED = 'JOB_REQUEST_ANSWERED',
  JOB_WITHDRAW = 'JOB_WITHDRAW',
  MISSION_ASSIGNED = 'MISSION_ASSIGNED',
  MISSION_CANCELLED = 'MISSION_CANCELLED',
  MISSION_FINISHED = 'MISSION_FINISHED',
  MISSION_PUBLISHED = 'MISSION_PUBLISHED',
  MISSION_UPDATED = 'MISSION_UPDATED',
  MISSION_VALIDATED = 'MISSION_VALIDATED',
  NETWORK_JOINED = 'NETWORK_JOINED',
  NETWORK_JOIN_REQUEST = 'NETWORK_JOIN_REQUEST',
  NETWORK_LEFT = 'NETWORK_LEFT',
  SPECIALTY_REQUEST = 'SPECIALTY_REQUEST',
  SPECIALTY_REQUEST_ANSWERED = 'SPECIALTY_REQUEST_ANSWERED',
  SPECIALTY_WITHDRAW = 'SPECIALTY_WITHDRAW',
}
